import React from "react";
import "./MessagesTab.css";

export default function MessagesTab() {
  return <div className="messages-tab">MessagesTab</div>;
}
